import React, { useContext } from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'
import { PagebuilderContext } from 'react-pagebuilder/services/pagebuilderContext'

const variantOpts = [
  { label: 'Primary', value: 'primary' },
  { label: 'Secondary', value: 'secondary' },
  { label: 'Ghost', value: 'ghost' },
]

const themeOpts = [
  { label: 'Light', value: 'light' },
  { label: 'Dark', value: 'dark' },
]

const iconPosOpts = [
  { label: 'Sinistra', value: 'left' },
  { label: 'Destra', value: 'right' },
]

export const ButtonSettings = (props) => {
  const { urlOpts } = useContext(PagebuilderContext)

  return (
    <>
      <ToolbarSection title="Style" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="ctaLabel"
          type="text"
          label="Testo"
          defaultValue={defaultProps['ctaLabel']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="variant"
          type="select"
          label="Variante"
          options={variantOpts}
          defaultValue={defaultProps['variant']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          label="Tema sfondo"
          options={themeOpts}
          defaultValue={defaultProps['theme']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="icon"
          type="icon"
          label="Icona"
          defaultValue={defaultProps['icon']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="iconPos"
          type="select"
          label="Posizione icona"
          options={iconPosOpts}
          defaultValue={defaultProps['iconPos']}
        />
      </ToolbarSection>
      {!props.floating && (
        <ToolbarSection title="Settings" initOpen>
          <ToolbarItem
            propKey="block"
            propSubKey="extUrl"
            type="text"
            label="URL"
            defaultValue={defaultProps['extUrl']}
          />
          {urlOpts && (
            <ToolbarItem
              propKey="block"
              propSubKey="url"
              type="select"
              label="Page Link"
              options={urlOpts}
              nullable
              defaultValue={defaultProps['url']}
            />
          )}
          <ToolbarItem
            propKey="block"
            propSubKey="openNewTab"
            type="switch"
            label="Apri in nuova finestra"
            defaultValue={defaultProps['openNewTab']}
          />
        </ToolbarSection>
      )}
    </>
  )
}

export const ButtonFloatingSettings = () => React.createElement(ButtonSettings, { floating: true })
